import React from 'react';
import './Logo.css';

interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ 
  variant = 'dark', 
  size = 'medium',
  className = ''
}) => {
  const logoSrc = variant === 'light' 
    ? '/logos/logo-light.png' 
    : '/logos/logo-dark.png';
  
  // Fallback to text if image not available
  const [imageError, setImageError] = React.useState(false);

  const show_image = !imageError;

  return (
    <div className={`logo logo--${size} ${className}`}>
      {show_image && (
        <img
          src={logoSrc}
          alt="FancyCloud"
          className="logo__image"
          onError={() => setImageError(true)}
        />
      )}
      <span className="logo__text">FancyCloud</span>
    </div>
  );
};
